import './Frame.css';

import React from 'react';
import { generateClassName } from './helpers';

const Frame = ({ title = '', className = null, children }) => {
    return (
        <div className={generateClassName("b2b-frame", "", className)}>
            <div className={generateClassName("b2b-frame", "-title", className)}>
                {title}
            </div>
            <div className={generateClassName("b2b-frame", "-container", className)}>
                {children}
            </div>
        </div>
    );
};

export default Frame;